// Session AM — how long ago an application's status last changed.
//
// The problem it solves: an agent who misclicks Accept or Remove cannot tell
// WHICH person they just actioned. The row re-sorts away and nothing on screen
// says when anything happened. "3 min ago" answers that instantly; a bare
// timestamp makes you compare against the clock.
//
// ⚠️ Returns '' for null. Applications decided BEFORE this column shipped have
// no value — the information was never recorded and must not be invented. An
// empty string renders as nothing, which is the honest answer.
export function statusAge(ts) {
  if (!ts) return '';
  const then = new Date(ts);
  if (isNaN(then.getTime())) return '';

  const mins = Math.floor((Date.now() - then.getTime()) / 60000);

  // A clock skew between the phone and the server can make a fresh decision
  // look like it happened in the future. Say "just now" rather than "-2 min".
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;

  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;

  // Past a day, "3d ago" stops being useful for finding a specific action, so
  // switch to the actual date. SAST is the operating timezone throughout.
  return then.toLocaleDateString('en-ZA', {
    day: 'numeric', month: 'short', timeZone: 'Africa/Johannesburg',
  }) + ' ' + then.toLocaleTimeString('en-ZA', {
    hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Africa/Johannesburg',
  });
}
